// Query key factory pattern for consistent cache management
// Following TanStack Query best practices 2025

import type { ITemplateListQuery, SpecType } from '@local/lib';

export const queryKeys = {
  all: ['app'],
  templates: {
    all: () => [...queryKeys.all, 'templates'],
    detail: (id: string) => [...queryKeys.templates.all(), id],
    list: (filters: Partial<ITemplateListQuery> & { specType?: SpecType } = {}) => [
      ...queryKeys.templates.all(),
      'list',
      filters,
    ],
    // Prefix (no filters object) covering every list query regardless of specType/pagination —
    // invalidating this, rather than a single filtered `list()` key, is what makes a create/
    // update/delete show up in every cached list view (e.g. the unfiltered Template Manager list)
    // without requiring a manual refresh.
    lists: () => [...queryKeys.templates.all(), 'list'],
  },
};
